import type { ProductProviderKey } from '~/lib/goliath/goliath.types';

export const providers: Record<ProductProviderKey, string> = {
  BRODOS: 'Brodos AG',
  TELEKOM: 'Telekom Deutschland GmbH',
  TVPP: 'Telekom Deutschland GmbH',
};

export const getProvider = (provider: ProductProviderKey | string | undefined) =>
  providers[provider as ProductProviderKey];
